export enum RiderDayEnum {
  ONE_SEVEN = 'ONE_SEVEN',
  EIGHT_FOURTEEN = 'EIGHT_FOURTEEN',
  FIFTEEN_TWENTY_ONE = 'FIFTEEN_TWENTY_ONE',
  TWENTY_TWO_MORE = 'TWENTY_TWO_MORE',
}
